export class HeartbeatManager {
  private readonly heartbeatUrl = '/service_worker/heartbeat';
  private readonly heartbeatInterval = 60 * 60 * 1000; // 60 minutes in ms

  private heartbeatIntervalId: NodeJS.Timeout | undefined;
  private serviceWorkerScope: ServiceWorkerGlobalScope;
  private version: string;

  public constructor(scope: ServiceWorkerGlobalScope, version: string) {
    this.serviceWorkerScope = scope;
    this.version = version;
  }

  private async sendHeartbeat(): Promise<void> {
    try {
      const clients = await this.serviceWorkerScope.clients.matchAll();

      // Only send heartbeat if there are windows open and the user is online
      if (clients.length > 0 && navigator.onLine) {
        const scopePath = new URL(this.serviceWorkerScope.registration.scope).pathname;
        await fetch(this.heartbeatUrl, {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            version: this.version,
            scope: scopePath,
          }),
          keepalive: true, // so it doesn't get killed by the browser mid-request
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error sending heartbeat:', error);
    }
  }

  public startHeartbeat(): void {
    if (this.heartbeatIntervalId !== undefined) {
      this.stopHeartbeat();
    }
    this.heartbeatIntervalId = setInterval(() => this.sendHeartbeat(), this.heartbeatInterval);
    this.sendHeartbeat();
  }

  public stopHeartbeat(): void {
    if (this.heartbeatIntervalId !== undefined) {
      clearInterval(this.heartbeatIntervalId);
      this.heartbeatIntervalId = undefined;
    }
  }
}
